import LogoCustom from 'assets/svg/logo-ralali-custom/logo-ralali-custom-footer.svg'
import LogoLandingFooterRamadhan from 'assets/svg/logo-ralali-default/logo-ralali-default.svg'
import Logo from 'assets/svg/logo-ralali-default/logo-ralali-default.svg'
import { ACTIVE_THEME_NAME } from 'common/constants'

function LandingFooterLogo(): JSX.Element {
  if (ACTIVE_THEME_NAME === 'anniversary')
    return <LogoCustom data-testid="landing-footer-logo-custom" />
  if (ACTIVE_THEME_NAME === 'ramadhan')
    return (
      <LogoLandingFooterRamadhan data-testid="landing-footer-logo-ramadhan" />
    )
  return <Logo data-testid="landing-footer-logo-default" />
}

export default LandingFooterLogo
